export interface ITicketStatus  {
    Status: string;
    Color: string;

}

export class TicketStatusArray extends Array<TicketStatus>  {

    constructor(...items: TicketStatus[]) {
        super(...items);
        Object.setPrototypeOf(this, TicketStatusArray.prototype);
    }

}

export class TicketStatus  implements ITicketStatus {
    Status: string;
    Color: string;

}
